import styled from '../../../../../styles/styledComponents/themeComponents';
import ListBox from '../../../../../components/outline/ListBox';

export const OrderManagementListStyle = styled(ListBox)`
  .list-box-head {
    align-items: center;

    .excel-btn-area {
      display: flex;
      gap: 10px;
    }
  }

  .list-box-body {
    .order-management-list-body-area {
      .row {
        display: flex;
        border-bottom: 1px solid #ebeef4;
      }

      .button-form {
        width: 50%;
        padding: 10px 0 10px 20px;
        & > div {
          display: inline-block;
        }

        .label {
          font-size: 14px;
          font-weight: 500;
          color: #767a83;
          width: 100px;
        }

        .button-list {
          button {
            font-size: 14px;

            &.base {
              color: #767a82;
              border-color: #d2d5dc;
            }
          }
        }
      }

      & > div {
        .button-form {
        }
      }
    }

    .order-management-list-table {
      margin-top: 10px;

      .ant-table-body {
        .ant-table-fixed {
          width: max-content !important;
        }
      }
    }
  }
`;
